import { Modal, Space, Table } from 'antd';
import React from 'react';

import { WEEK_DAYS_MON_START } from '@/constants/date';

import { MODAL_BODY_STYLES } from '../constants';
import {
  FIXED_SCHEDULE_TABLE_COLUMNS,
  NON_FIXED_SCHEDULE_TABLE_COLUMNS,
} from './constants';
import styles from './index.module.scss';
import type { ProgramScheduleData } from './types';

type ProgramScheduleModalProps = {
  open: boolean;
  closeModal: () => void;
  schedule: ProgramScheduleData;
};

export const ProgramScheduleModal = ({
  open,
  closeModal,
  schedule,
}: ProgramScheduleModalProps) => {
  const fixedSchedule = schedule.fixedSchedule;
  const nonFixedSchedule = schedule.nonFixedSchedule;

  const hasFixedSchedule = !!fixedSchedule && fixedSchedule.length > 0;
  const hasNonFixedSchedule = !!nonFixedSchedule && nonFixedSchedule.length > 0;

  return (
    <Modal
      centered
      destroyOnClose
      maskClosable={false}
      open={open}
      onCancel={closeModal}
      bodyStyle={MODAL_BODY_STYLES}
      footer={null}
    >
      <Space direction="vertical" size="large" className={styles.modalContent}>
        {hasFixedSchedule && (
          <Table
            bordered
            title={() => <h2>固定時間表</h2>}
            scroll={{ x: 'max-content' }}
            pagination={false}
            columns={FIXED_SCHEDULE_TABLE_COLUMNS}
            dataSource={fixedSchedule
              .map((item, index) => ({
                ...item,
                key: index,
                day: '週' + WEEK_DAYS_MON_START[index],
              }))
              .filter((item) => item.isDayChecked)}
          />
        )}

        {hasNonFixedSchedule && (
          <Table
            bordered
            title={() => <h2>非固定時間表</h2>}
            scroll={{ x: 'max-content' }}
            columns={NON_FIXED_SCHEDULE_TABLE_COLUMNS}
            dataSource={nonFixedSchedule.map((item, index) => ({
              ...item,
              key: index,
            }))}
          />
        )}
      </Space>
    </Modal>
  );
};
